import { useLocation } from 'react-router-dom';
import { updateSearchParam } from '../../core/util/updateSearchParams';
import removeSearchParam from '../../core/util/removeSearchParam';
import usePagination from './usePagination';

const useSearchParamFilterHelper = () => {
    const { search } = useLocation();
    const { navigateToPage } = usePagination();
    const searchParams = new URLSearchParams(search);

    return (filterName: string) => {
        const selectedValues = searchParams.getAll(filterName);

        const submitFilter = (values: string[]) => {
            const updatedSearchParams = updateSearchParam(
                searchParams,
                filterName,
                values
            );
            navigateToPage(1, updatedSearchParams.toString());
        };

        const removeFilter = () => {
            const updatedSearchParams = removeSearchParam(
                searchParams,
                filterName
            );
            navigateToPage(1, updatedSearchParams.toString());
        };

        const updateCurrentValues = (
            value: string,
            isRemove = false,
            isReplace = false
        ) => {
            if (isReplace) {
                submitFilter(value ? [value] : []);
                return;
            }

            const updatedValues = new Set(selectedValues.slice());
            if (isRemove) {
                updatedValues.delete(value);
            } else {
                updatedValues.add(value);
            }

            submitFilter(Array.from(updatedValues));
        };

        return {
            updateCurrentValues,
            selectedValues,
            submitFilter,
            removeFilter,
        };
    };
};

export default useSearchParamFilterHelper;
